import type { ParsedQs } from 'qs'

type QueryParam = ParsedQs[string]

/** Returns the param, if it's a string. */
export function stringParam(v: QueryParam): string | undefined {
  return typeof v === 'string' ? v : undefined
}

/** Returns the param as an array of strings, if's already an array of strings or a single string. */
export function stringArrayParam(v: QueryParam): Array<string> | undefined {
  if (typeof v === 'string') return [v]
  if (Array.isArray(v) && v.every(e => typeof e === 'string')) return v
  return undefined
}
